import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-55faee58"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "stations-map-root" }
const _hoisted_2 = { class: "stations-map" }
const _hoisted_3 = {
  ref: "mapRef",
  class: "map-inner"
}
const _hoisted_4 = { ref: "popupRef" }
const _hoisted_5 = {
  key: 0,
  class: "loading-overlay"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "loading-spinner" }, null, -1))
const _hoisted_7 = [
  _hoisted_6
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ErrorDisplay = _resolveComponent("ErrorDisplay")!
  const _component_StationMapPopup = _resolveComponent("StationMapPopup")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.errorMessage)
      ? (_openBlock(), _createBlock(_component_ErrorDisplay, {
          key: 0,
          title: _ctx.errorMessage,
          text: _ctx.errorText,
          class: "mb-4"
        }, null, 8, ["title", "text"]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, null, 512),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_StationMapPopup, {
          ref: "stationPopupRef",
          isLinkEnabled: _ctx.isLinkEnabled,
          stationId: _ctx.selectedStationId,
          onClose: _cache[0] || (_cache[0] = ($event: any) => (_ctx.selectedStationId = null))
        }, null, 8, ["isLinkEnabled", "stationId"])
      ], 512),
      (_ctx.isRequestInProgress)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, _hoisted_7))
        : _createCommentVNode("", true)
    ])
  ]))
}